/** Finance console sub-navigation (§16.2: balanced ledger, provider reconciliation, refunds, payout maker/checker). */
import { SubNav } from '../../components/Tabs';

const LINKS = [
  { to: '/finance', label: 'Reconciliation', end: true },
  { to: '/finance/refunds', label: 'Refunds' },
  { to: '/finance/payouts', label: 'Payouts' },
  { to: '/finance/ledger', label: 'Ledger' },
];

export function FinanceNav() {
  return <SubNav label="Finance sections" links={LINKS} />;
}

export const money = (m: { amountMinor: string; currency: string }, fmt: (a: string, c: string) => string) =>
  fmt(m.amountMinor, m.currency);
